import axios from "axios";
import { user_token } from "./jwt_store";
import { base_url } from "./tastummy_login";
let auth_header = "";
user_token.subscribe((token) => {
    auth_header = `Bearer ${token}`;
});
const my_axios = axios.create({
    baseURL: base_url + "/api",
});
my_axios.interceptors.request.use(async (config) => {
    config.headers.Authorization = auth_header;
    return config;
}, (error) => {
    Promise.reject(error);
});
my_axios.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401) {
        // wait half a second before resending the request
        await new Promise((resolve) => setTimeout(resolve, 500));
        originalRequest._retry = true;
        axios.defaults.headers.common["Authorization"] = auth_header;
        return my_axios(originalRequest);
    }
    return Promise.reject(error);
});
export const get_recipes = () => {
    return my_axios({
        method: "get",
        url: "recipe",
    });
};
export const get_recipe = (recipe_id) => {
    return my_axios({
        method: "get",
        url: "recipe/" + recipe_id,
    });
};
export const submit_recipe = (recipe) => {
    return my_axios({
        method: "put",
        url: "recipe/" + recipe.id,
        data: recipe,
    });
};
// get aisle options
export const get_aisle_options = () => {
    return my_axios({
        method: "get",
        url: "aisles",
    });
};
// import recipe
export const import_recipe = (recipe_id) => {
    return my_axios({
        method: "post",
        url: "recipe/" + recipe_id + "/import",
    });
};
// delete recipe
export const delete_recipe = (recipe_id) => {
    return my_axios({
        method: "delete",
        url: "recipe/" + recipe_id,
    });
};
// import new recipe
export const import_recipe_from_url = (recipe_url) => {
    return my_axios({
        method: "post",
        url: "recipe",
        data: { url: recipe_url },
    });
};
// import recipe using json blob
export const import_recipe_by_json = (json) => {
    return my_axios({
        method: "post",
        url: "recipe_json",
        data: json,
    });
};
export const get_tags = () => {
    return my_axios({ method: "get", url: "tags" });
};
// get grocery list
export const get_grocery_list = (list_id) => {
    return my_axios({
        method: "get",
        url: "grocery/" + list_id,
    });
};
// create grocery list
export const create_grocery_list = (grocery_list) => {
    let list = {
        items: grocery_list,
        name: `list ${new Date().toLocaleString()}`,
        owner: "",
    };
    return my_axios({
        method: "post",
        url: "grocery",
        data: list,
    });
};
// update grocery list
export const update_grocery_list = (grocery_list) => {
    return my_axios({
        method: "put",
        url: "grocery/" + grocery_list.id,
        data: grocery_list,
    });
};
// delete grocery list
export const delete_grocery_list = (grocery_list_id) => {
    return my_axios({
        method: "delete",
        url: "grocery/" + grocery_list_id,
    });
};
// get all grocery lists
export const get_all_grocery_lists = () => {
    return my_axios({
        method: "get",
        url: "grocery",
    });
};
// get user settings
export const get_user_settings = () => {
    return my_axios({
        method: "get",
        url: "settings",
    });
};
// login to kroger through tastummy
export const login_kroger = (code) => {
    return my_axios({
        method: "post",
        url: "kroger/login",
        data: { code: code },
    });
};
// logout from kroger through tastummy
export const logout_kroger = () => {
    return my_axios({
        method: "delete",
        url: "kroger/login",
    });
};
// add to kroger cart
export const add_to_kroger_cart = () => {
    return my_axios({
        method: "post",
        url: "kroger/cart",
    });
};
